import axios from 'axios';

// The Splunk logging proxy (proxy.refclient.ext.here.com) is a CNAME into HERE's
// internal network (borg-p.nw.ops.here.com) and has no public DNS record, so it
// only resolves inside the HERE network. Now that the dashboards are served
// publicly (outside the HERE network), the browser cannot resolve it and every
// log call fails with ERR_NAME_NOT_RESOLVED. Remote logging is therefore opt-in
// and only attempted for deployments that run inside the HERE network
// (REACT_APP_ENABLE_REMOTE_LOG=true).
const REMOTE_LOGGING_ENABLED = process.env.REACT_APP_ENABLE_REMOTE_LOG === 'true';

const defaultLogger = (message = {}, severity) => {
  const source = window.location.hostname;
  const url = window.location.href;
  const metadata = { source };
  if (process.env.NODE_ENV === 'production') {
    if (REMOTE_LOGGING_ENABLED) {
      axios
        .post(`https://proxy.refclient.ext.here.com/log`, {
          message: { ...message, url },
          severity,
          metadata,
        })
        .catch(() => {});
    }
  } else if (severity === 'error') {
    console.error('splunk log', { ...message, url });
  } else {
    // eslint-disable-next-line no-console
    console.log('splunk log', { ...message, url });
  }
};

export const logError = (error = {}) => {
  const errorStr = `${error.message}\n${error.stack}`;
  defaultLogger({ error: errorStr }, 'error');
  console.error(error);
};

export default defaultLogger;
